<template>
  <div :id="field.id">
    <p v-if="field.label" for="input" class="text-argus-forest-600 mb-3 font-semibold">
      {{ field.label }}
      <span v-if="field.required" class="text-argus-error">*</span>
    </p>

    <template v-if="field.help_text">
      <p class="text-sm text-argus-forest-600 mb-6">{{ field.help_text }}</p>
    </template>

    <div class="flex flex-col items-center w-full mb-2">
      <label
        v-for="(option, index) in field.options"
        :key="`option-${index}`"
        class="flex w-full mb-4 cursor-pointer"
        :for="`${field.id}-radio-option-${index}`"
      >
        <input
          :name="`${field.id}-radio-group`"
          :id="`${field.id}-radio-option-${index}`"
          type="radio"
          class="mt-1 w-4 h-4 checked:bg-argus-brand text-argus-brand mr-2"
          @change="updateValue(option)"
          v-model="selected"
          :value="option.value"
        />
        <p class="text-argus-forest-600 w-fit text-sm">
          <span class="font-semibold">{{ option.label }}.</span> {{ option.description }}
        </p>
      </label>
    </div>

    <template v-if="field.error">
      <p class="text-argus-error text-sm py-[4px]">{{ errorMessage }}</p>
    </template>

    <div v-if="selectedOption" class="flex flex-col w-full">
      <p
        v-if="selectedOption.selected_label"
        class="text-argus-forest-800 text-2xl font-semibold mb-2"
      >
        {{ selectedOption.selected_label }}
      </p>
      <div v-for="f in selectedOptionFields" :key="f.id" class="my-2">
        <FieldDisplay :field="f" @update="updateFieldValue(f, $event)" :ref="f.id" />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import FieldDisplay from '@/components/common/FieldDisplay.vue'

export default {
  components: {
    FieldDisplay,
  },
  props: {
    field: Object,
  },
  emits: ['update'],
  watch: {
    'field.value': {
      handler(val) {
        if (val) {
          this.selected = val
        }
      },
      deep: true,
      immediate: true,
    },
    'field.fields': {
      handler(val) {
        if (val) {
          const choice = this.field.choices.find((c) => c.label === this.field.value)
          if (choice) {
            choice.fields = _.cloneDeep(val)
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    formattedLabel() {
      return
    },
    selectedOption() {
      if (!this.selected) return []

      const option = this.field.options.find((c) => c.value === this.selected)
      return option
    },
    selectedOptionFields() {
      if (!this.selectedOption) return []

      return this.selectedOption.fields
    },
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      //Validate all fields under selected choice
      if (this.selectedOptionFields) {
        const that = this

        const isValid = this.selectedOptionFields.every((field) => {
          if (!that.getFieldRef(field)) {
            return false
          }
          return that.getFieldRef(field).isValid
        })
        return isValid
      }
      return true
    },
  },
  mounted() {},
  data() {
    return {
      selected: null,
      errorMessage: '',
      touched: false,
    }
  },
  methods: {
    getFieldRef(field) {
      let fieldEl = this.$refs[field.id]
      if (Array.isArray(fieldEl)) {
        fieldEl = this.$refs[field.id][0]
      }
      return fieldEl
    },
    updateValue() {
      this.touched = true
      this.$emit('update', this.selected)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
        }
      } else {
        this.errorMessage = ''
      }

      this.selectedOptionFields.forEach((f) => {
        const fieldEl = this.getFieldRef(f)
        f.error = !fieldEl.isValid
      })
    },
    updateFieldValue(field, val) {
      this.selectedOptionFields.forEach((f) => {
        if (f.id === field.id) {
          f.value = val
        }
      })

      this.updateValue()
    },
  },
}
</script>
<style scoped>
input[type='radio']:focus {
  outline: none;
  box-shadow: none;
}
</style>
